export default __webpack_public_path__ + "static/punten-f9d357f309e13d8b3d216d55a7997a50.gif";